import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNotEmptyStringPipe'
})
export class IsNotEmptyStringPipe implements PipeTransform {

  transform(str: any): boolean {
    return typeof str === 'string' && str.length > 0;
  }

}
